document.addEventListener('click', function(e) {
  if(e.target.classList.contains('scroll-to')){
    const to = e.target.getAttribute('data-to');
    const element = document.getElementById(to);
    if(element){
      element.scrollIntoView({behavior: 'smooth'});
    }
  }
});
